function appendMonthToMonths(input: HTMLInputElement, language: string) {
  input.value = `${input.value} ${language === 'es' ? 'meses' : 'months'}`
  input.addEventListener('focus', () => {
    const indexOfM = input.value.indexOf('m')
    input.setSelectionRange(0, indexOfM)
  })
}

export default function initAppendMonths(node: Element, language: string) {
  Array.from(node.querySelectorAll('[month]')).forEach((monthInput) => {
    appendMonthToMonths(monthInput as HTMLInputElement, language)
  })
}
